import * as React from 'react';

import CampaignModulesDataProviderForXdp from 'bundles/campaigns/providers/CampaignModulesDataProviderForXdp';
import { savedProductTypes } from 'bundles/unified-description-page-common/constants';
import PortfolioProjectCheckProvider from 'bundles/unified-description-page-common/providers/PortfolioProjectCheckProvider';
import SubscriptionsForwardDiscoveryDataProvider from 'bundles/unified-description-page-common/providers/SubscriptionsForwardDiscoveryDataProvider';
import { CourseArticlesRecsDataProvider } from 'bundles/unified-description-page-common/providers/consumer/ArticlesRecommendationsDataProvider';
import { CourseCourseraPlusOwnershipDataProvider } from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusOwnershipDataProvider';
import CourseraPlusSavedProductDataProvider from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusSavedProductDataProvider';
import ConsumerBffCourseDataProvider from 'bundles/unified-description-page-common/providers/consumer/bff/ConsumerBffCourseDataProvider';
import RecommendationsDataProvider from 'bundles/unified-description-page-common/providers/specialization/RecommendationsDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

type Props = {
  children: React.ReactNode;
};

const ConsumerProjectPageDataProvider = ({ children }: Props) => {
  return (
    // Projects are a course under the hood. Use same provider as course page bff content.
    <ConsumerBffCourseDataProvider>
      <CampaignModulesDataProviderForXdp>
        <PortfolioProjectCheckProvider>
          <CourseCourseraPlusOwnershipDataProvider>
            <CourseraPlusSavedProductDataProvider savedProductType={savedProductTypes.GUIDED_PROJECT}>
              <UserDataProvider includeOpenCourseMemberships>
                <CourseArticlesRecsDataProvider>
                  <SubscriptionsForwardDiscoveryDataProvider>
                    <RecommendationsDataProvider productVariant="project">{children}</RecommendationsDataProvider>
                  </SubscriptionsForwardDiscoveryDataProvider>
                </CourseArticlesRecsDataProvider>
              </UserDataProvider>
            </CourseraPlusSavedProductDataProvider>
          </CourseCourseraPlusOwnershipDataProvider>
        </PortfolioProjectCheckProvider>
      </CampaignModulesDataProviderForXdp>
    </ConsumerBffCourseDataProvider>
  );
};

export default ConsumerProjectPageDataProvider;
